import { PaletteOptions } from '@mui/material/styles'

export const palette: PaletteOptions = {
  mode: 'light',

  primary: {
    main: '#2023AA',
    light: '#1B4AC2',
    dark: '#191B80',
    contrastText: '#FFFFFF'
  },

  secondary: {
    main: '#1B4AC2',
    light: '#A1BBFF',
    dark: '#142F7A',
    contrastText: '#FFFFFF'
  },

  error: {
    main: '#D32F2F',
    light: '#EF5350',
    dark: '#C62828'
  },

  warning: {
    main: '#ED6C02'
  },

  success: {
    main: '#2E7D32',
    light: '#4CAF50'
  },

  grey: {
    50: '#F8F9FC',
    100: '#F0F3F8',
    200: '#E1E8F0',
    300: '#C8D3E0',
    400: '#9AADC4',
    500: '#6B87A8',
    600: '#4A6585',
    700: '#2F4A6B',
    800: '#1E3050',
    900: '#111D33'
  },

  background: {
    default: '#FAFAFA',
    paper: '#FFFFFF'
  },

  text: {
    primary: '#4C4C4C',
    secondary: '#B7B7B7',
    disabled: '#B7B7B7'
  },

  divider: 'rgba(0, 0, 0, 0.12)'
}
